"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _preact = require("preact");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_DURATION = 300;
var DEFAULT_EASING = 'ease-in-out';

function hasValidChildren(children) {
  var firstChild = Array.isArray(children) ? children[0] : children;
  return !!(firstChild && (0, _typeof2.default)(firstChild) === 'object' && 'type' in firstChild);
}

var AnimateTransition = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AnimateTransition, _Component);

  var _super = _createSuper(AnimateTransition);

  function AnimateTransition() {
    var _this$props$state;

    var _this;

    (0, _classCallCheck2.default)(this, AnimateTransition);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "elementRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "currentAnimation", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isServer", typeof window === 'undefined');
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "lastValidChildren", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      currentState: (_this$props$state = _this.props.state) !== null && _this$props$state !== void 0 ? _this$props$state : 'initial',
      isAnimating: false,
      shouldRender: hasValidChildren(_this.props.children)
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "applyStaticStyles", function (stateName) {
      var states = _this.getStates();

      var stateConfig = states[stateName];
      if (!stateConfig || !_this.elementRef || !stateConfig.keyframes.length) return;
      var finalKeyframe = stateConfig.keyframes[stateConfig.keyframes.length - 1];
      Object.entries(finalKeyframe).forEach(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
            property = _ref2[0],
            value = _ref2[1];

        _this.elementRef.style[property] = String(value);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "applyInitialState", function () {
      var state = _this.props.state;
      var currentState = state !== null && state !== void 0 ? state : _this.state.currentState;

      _this.applyStaticStyles(currentState);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "animateToState", function (newState) {
      var _toStateConfig$durati, _toStateConfig$easing;

      var _this$props = _this.props,
          defaultDuration = _this$props.defaultDuration,
          defaultEasing = _this$props.defaultEasing,
          onAnimationStart = _this$props.onAnimationStart,
          onAnimationEnd = _this$props.onAnimationEnd;

      var states = _this.getStates();

      var fromState = _this.state.currentState;
      var toStateConfig = states[newState];

      if (!toStateConfig || !_this.elementRef) {
        _this.setState({
          currentState: newState
        });

        return;
      }

      if (_this.currentAnimation) {
        _this.currentAnimation.cancel();
      }

      var duration = (_toStateConfig$durati = toStateConfig.duration) !== null && _toStateConfig$durati !== void 0 ? _toStateConfig$durati : defaultDuration;
      var easing = (_toStateConfig$easing = toStateConfig.easing) !== null && _toStateConfig$easing !== void 0 ? _toStateConfig$easing : defaultEasing;

      _this.setState({
        isAnimating: true
      });

      if (onAnimationStart) {
        onAnimationStart(fromState, newState);
      }

      try {
        _this.currentAnimation = _this.elementRef.animate(toStateConfig.keyframes, {
          duration: duration,
          easing: easing,
          fill: 'forwards'
        });

        _this.currentAnimation.onfinish = function () {
          var _this$props$exit;

          _this.currentAnimation = null;
          var finalKeyframe = toStateConfig.keyframes[toStateConfig.keyframes.length - 1];
          Object.entries(finalKeyframe).forEach(function (_ref3) {
            var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
                property = _ref4[0],
                value = _ref4[1];

            _this.elementRef.style[property] = String(value);
          });

          _this.setState({
            currentState: newState,
            isAnimating: false
          });

          var exitKey = (_this$props$exit = _this.props.exit) !== null && _this$props$exit !== void 0 ? _this$props$exit : 'exit';

          if (newState === exitKey) {
            _this.setState({
              shouldRender: false
            });

            _this.lastValidChildren = null;
          }

          if (onAnimationEnd) {
            onAnimationEnd(fromState, newState, _this.elementRef);
          }
        };
      } catch (error) {
        var _this$props$exit2;

        console.warn('Animation failed, applying styles directly:', error);

        _this.applyStaticStyles(newState);

        _this.setState({
          currentState: newState,
          isAnimating: false
        });

        var exitKey = (_this$props$exit2 = _this.props.exit) !== null && _this$props$exit2 !== void 0 ? _this$props$exit2 : 'exit';

        if (newState === exitKey) {
          _this.setState({
            shouldRender: false
          });

          _this.lastValidChildren = null;
        }
      }
    });
    return _this;
  }

  (0, _createClass2.default)(AnimateTransition, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.isServer) {
        return;
      }

      var _this$props2 = this.props,
          initial = _this$props2.initial,
          enter = _this$props2.enter;

      if (initial !== null && initial !== void 0 ? initial : enter) {
        if (initial) {
          this.applyStaticStyles(initial);
        }

        if (enter) {
          requestAnimationFrame(function () {
            _this2.animateToState(enter);
          });
        }
      } else {
        this.applyInitialState();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          state = _this$props3.state;
      var hadChildren = hasValidChildren(prevProps.children);
      var hasChildren = hasValidChildren(children); // Store valid children for exit animation

      if (hasChildren) {
        this.lastValidChildren = children;
      }

      if (hadChildren && !hasChildren && this.state.shouldRender) {
        var _this$props$exit3;

        var exitKey = (_this$props$exit3 = this.props.exit) !== null && _this$props$exit3 !== void 0 ? _this$props$exit3 : 'exit';
        this.animateToState(exitKey);
      } else if (!hadChildren && hasChildren) {
        if (!this.state.shouldRender) {
          this.setState({
            shouldRender: true
          }, function () {
            requestAnimationFrame(function () {
              var _this3$props$enter;

              var enterKey = (_this3$props$enter = _this3.props.enter) !== null && _this3$props$enter !== void 0 ? _this3$props$enter : 'enter';

              _this3.animateToState(enterKey);
            });
          });
        } else {
          var _this$props$enter;

          var enterKey = (_this$props$enter = this.props.enter) !== null && _this$props$enter !== void 0 ? _this$props$enter : 'enter';
          this.animateToState(enterKey);
        }
      } else if (state && prevProps.state !== state && !this.isServer) {
        this.animateToState(state);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.currentAnimation) {
        this.currentAnimation.cancel();
      }

      this.lastValidChildren = null;
    }
  }, {
    key: "getStates",
    value: function getStates() {
      var states = this.props.states;
      return states !== null && states !== void 0 ? states : {};
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var children = this.props.children;
      var _this$state = this.state,
          isAnimating = _this$state.isAnimating,
          shouldRender = _this$state.shouldRender;

      if (!shouldRender) {
        return null;
      }

      var childrenToRender = hasValidChildren(children) ? children : this.lastValidChildren;
      var firstChild = Array.isArray(childrenToRender) ? childrenToRender[0] : childrenToRender;

      if (!firstChild) {
        return null;
      }

      if ((0, _typeof2.default)(firstChild) !== 'object' || !('type' in firstChild)) {
        return null;
      }

      var refHandler = function refHandler(el) {
        var _firstChild$props;

        _this4.elementRef = el;

        if ((_firstChild$props = firstChild.props) !== null && _firstChild$props !== void 0 && _firstChild$props.ref) {
          if (typeof firstChild.props.ref === 'function') {
            firstChild.props.ref(el);
          } else {
            firstChild.props.ref.current = el;
          }
        }
      };

      return (0, _preact.cloneElement)(firstChild, _objectSpread(_objectSpread(_objectSpread({}, firstChild.props), typeof firstChild.type === 'string' ? {
        ref: refHandler
      } : {
        forwardedRef: refHandler
      }), {}, {
        'data-animated-state': this.state.currentState,
        'data-animating': isAnimating
      }));
    }
  }]);
  return AnimateTransition;
}(_preact.Component);

(0, _defineProperty2.default)(AnimateTransition, "defaultProps", {
  defaultDuration: DEFAULT_DURATION,
  defaultEasing: DEFAULT_EASING
});
var _default = AnimateTransition;
exports.default = _default;